const sortByTag = (a, b) => {
  const aTag = a.tag;
  const bTag = b.tag;

  if (aTag && !bTag) {
    return -1;
  }
  if (!aTag && bTag) {
    return 1;
  }

  return 0;
};

export const sortByCost = (a, b) => {
  const aName = a.name;
  const aTotalCost = a.rate?.totalCost?.value ?? 0;
  const aTotalCostCode = a.rate?.totalCost?.code ?? 0;

  const bName = b.name;
  const bTotalCost = b?.rate?.totalCost?.value ?? 0;
  const bTotalCostCode = b?.rate?.totalCost?.code ?? 0;

  if (aTotalCostCode === bTotalCostCode) {
    if (aTotalCost !== bTotalCost) {
      return aTotalCost - bTotalCost;
    }
    return aName?.localeCompare(bName) ?? 0;
  }

  return bTotalCostCode - aTotalCostCode;
};

export const sortByTagThenByCost = (a, b) => {
  const tagSort = sortByTag(a, b);
  if (tagSort !== 0) {
    return tagSort;
  }

  return sortByCost(a, b);
};
